"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertfanHistoryApi = exports.AlertfanHistoryApiFactory = exports.AlertfanHistoryApiFp = exports.AlertfanHistoryApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AlertfanHistoryApi - axios parameter creator
 * @export
 */
const AlertfanHistoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory: (alertHistoryRequestDTO_1, ...args_1) => __awaiter(this, [alertHistoryRequestDTO_1, ...args_1], void 0, function* (alertHistoryRequestDTO, options = {}) {
            const localVarPath = `/alertfan/history/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertHistoryRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanHistoryApiAxiosParamCreator = AlertfanHistoryApiAxiosParamCreator;
/**
 * AlertfanHistoryApi - functional programming interface
 * @export
 */
const AlertfanHistoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanHistoryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(alertHistoryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistory(alertHistoryRequestDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanHistoryApi.getHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AlertfanHistoryApiFp = AlertfanHistoryApiFp;
/**
 * AlertfanHistoryApi - factory interface
 * @export
 */
const AlertfanHistoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanHistoryApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertfanHistoryApiGetHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(requestParameters = {}, options) {
            return localVarFp.getHistory(requestParameters.alertHistoryRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanHistoryApiFactory = AlertfanHistoryApiFactory;
/**
 * AlertfanHistoryApi - object-oriented interface
 * @export
 * @class AlertfanHistoryApi
 * @extends {BaseAPI}
 */
class AlertfanHistoryApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertfanHistoryApiGetHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanHistoryApi
     */
    getHistory(requestParameters = {}, options) {
        return (0, exports.AlertfanHistoryApiFp)(this.configuration).getHistory(requestParameters.alertHistoryRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanHistoryApi = AlertfanHistoryApi;
//# sourceMappingURL=alertfan-history-api.js.map